import { atom, useAtom } from "jotai";
import React, { useEffect, useRef } from "react";

import Toast, { ToastType } from "src/components/Toasts/Toast.tsx";
import { useT } from "src/internationalization";

const toastsAtom = atom<ToastType[]>([]);

const defaultTimeout = 2000;

const ToastContainer: React.FC = () => {
  const [toasts, setToasts] = useAtom(toastsAtom);
  const intervals = useRef<ReturnType<typeof setInterval>>(undefined);

  useEffect(() => {
    if (toasts.length === 0) return;
    // deletes one toast every 2 seconds
    intervals.current = setInterval(() => {
      setToasts(() => {
        return toasts.filter((t) => t.id !== toasts[0].id);
      });
    }, defaultTimeout);

    return () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      clearInterval(intervals.current as any);
    };
  }, [toasts, setToasts]);

  return (
    <div className="absolute top-10 right-6 z-[99999]">
      {toasts.map(({ kind, id, title, subtitle }) => {
        return (
          <Toast
            key={id}
            kind={kind}
            id={id}
            title={title}
            subtitle={subtitle}
            onclose={() =>
              setToasts((prev) => {
                return prev.filter((t) => t.id !== id);
              })
            }
          />
        );
      })}
    </div>
  );
};

export const useToast = () => {
  const [, setToasts] = useAtom(toastsAtom);
  const t = useT();

  return {
    showToast: (toast: Omit<ToastType, "id">) => {
      setToasts((prev) => {
        return [...prev, { ...toast, id: Math.random().toString() }];
      });
    },
    showErrorToast: (message: string) => {
      setToasts((prev) => {
        return [
          ...prev,
          {
            id: Math.random().toString(),
            title: t("component.toast.container.title"),
            subtitle: message,
            kind: "error",
          },
        ];
      });
    },
    showSuccessToast: (message: string) => {
      setToasts((prev) => {
        return [
          ...prev,
          {
            id: Math.random().toString(),
            title: "",
            subtitle: message,
            kind: "success",
          },
        ];
      });
    },
  };
};

export default ToastContainer;
